function CompanyStoreService() {
    'ngInject';

    return {
        country_code: null,
        currency_code: null,
        time_zone: null,
        settings: null
    };
}

angular
    .module('BB')
    .service('CompanyStoreService', CompanyStoreService);


// WEBPACK FOOTER //
// node_modules/bookingbug-angular/src/core/_services/company_store.service.js